module.exports = __webpack_public_path__ + "img/hr-filter-inserter-hand-closed.44bb9396.png";